export const NotificationStatus = {
    Success: 'Success',
    Failure: 'Failure',
    Warning: 'Warning',
    Error: 'Error'
}